"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attributeNameInconsistentRule = void 0;
exports.checkNamingConsistency = checkNamingConsistency;
const utils_1 = require("@azimutt/utils");
const database_1 = require("../../database");
const databaseUtils_1 = require("../../databaseUtils");
const rule_1 = require("../rule");
const entityNameInconsistent_1 = require("./entityNameInconsistent");
/**
 * Keeping the same naming convention for all your columns will help avoid typos and understand things.
 */
const ruleId = 'attribute-name-inconsistent';
const ruleName = 'inconsistent attribute name';
const ruleDescription = 'attributes with names not following the most common convention among attribute names';
const CustomRuleConf = rule_1.RuleConf.extend({
    ignores: database_1.AttributeId.array().optional(),
}).strict().describe('AttributeNameInconsistentConf');
exports.attributeNameInconsistentRule = {
    id: ruleId,
    name: ruleName,
    description: ruleDescription,
    conf: { level: rule_1.RuleLevel.enum.low },
    zConf: CustomRuleConf,
    analyze(conf, now, db, queries, history, reference) {
        const refIgnores = reference.map(r => r.entity && r.attribute ? { ...r.entity, attribute: r.attribute } : undefined).filter(utils_1.isNotUndefined);
        const ignores = refIgnores.concat(conf.ignores?.map(databaseUtils_1.attributeRefFromId) || []);
        const inconsistencies = checkNamingConsistency(db.entities || []);
        return inconsistencies.invalid
            .filter(a => !ignores.some(i => (0, databaseUtils_1.attributeRefSame)(i, a)))
            .map(attribute => ({
            ruleId,
            ruleName,
            ruleLevel: conf.level,
            message: `Attribute ${(0, databaseUtils_1.attributeRefToId)(attribute)} doesn't follow naming convention ${inconsistencies.convention}.`,
            entity: (0, databaseUtils_1.entityRefFromAttribute)(attribute),
            attribute: attribute.attribute
        }));
    }
};
// same as frontend/src/PagesComponents/Organization_/Project_/Views/Modals/SchemaAnalysis/NamingConsistency.elm
function checkNamingConsistency(entities) {
    const counts = entities.reduce((acc, entity) => (0, databaseUtils_1.flattenAttributes)(entity.attrs).reduce((acc, a) => (0, entityNameInconsistent_1.addCases)(acc, a.name), acc), {});
    const attributeCase = (0, entityNameInconsistent_1.bestCase)(counts);
    return {
        convention: attributeCase.name,
        invalid: entities.flatMap(e => (0, databaseUtils_1.flattenAttributes)(e.attrs).filter(a => !attributeCase.isValid(a.name)).map(a => ({ ...(0, databaseUtils_1.entityToRef)(e), attribute: a.path })))
    };
}
//# sourceMappingURL=attributeNameInconsistent.js.map